module.exports = __webpack_public_path__ + "img/Weapon_236.8e498c22.png";